import { Children } from "react"
import { Helmet } from "react-helmet"
import { useSelector } from "react-redux"
import { Link } from "react-router-dom"
import { Loading, PageLanding } from "../components"
import { getText } from "../redux"
import "../style/About.scss"
import { splitText } from "../utils"

function About() {
	const about = useSelector(state => getText(state, "about"))

	const membersMap = member => {
		const { image, name, role } = member
		return (
			<div className="about__members__item">
				<img src={image} alt={name} />
				<h4>{name}</h4>
				<p>{role}</p>
			</div>
		)
	}

	const technologiesMap = technology => {
		return <img src={technology} alt="technology" />
	}

	if (!about) return <Loading />

	return (
		<div className="about">
			<Helmet>
				<title>Despre Noi | Agentie de Web Design - Xposed Agency</title>
				<meta
					name="description"
					content="Despre Noi | Agentie de Web Design - Xposed Agency"
				/>
			</Helmet>

			<PageLanding
				src={about.mainImage}
				title={about.title}
				description={about.description}
			/>

			<div className="about__section">
				<div className="about__members">
					<div
						className="section__top section__top__about"
						style={{ paddingTop: 50 }}
					>
						<h3>ECHIPA NOASTRA</h3>

						<div className="section__top__right">
							<p>{splitText(about.teamDescription)}</p>
						</div>
					</div>

					<div className="about__members__items">
						{Children.toArray(about.members.map(membersMap))}
					</div>
				</div>

				<div className="section__top section__top__about about__contact">
					<h3>{about?.contact?.subtitle}</h3>

					<div className="section__top__right">
						<h1>{splitText(about?.contact?.title)}</h1>

						<div
							className="pageLanding__text__separator"
							style={{ margin: "20px 0" }}
						/>

						<p>{splitText(about?.contact?.description)}</p>

						<Link to="/contact">CONTACTEAZA-NE</Link>
					</div>
				</div>

				<div className="about__technologies">
					<div
						className="section__top section__top__about"
						style={{ paddingTop: 50 }}
					>
						<h3>TEHNOLOGII UTILIZATE</h3>
						<div className="section__top__right">
							<p>{splitText(about.teamDescription)}</p>
						</div>
					</div>

					<div className="about__technologies__items">
						{Children.toArray(about.technologies.map(technologiesMap))}
					</div>
				</div>
			</div>
		</div>
	)
}

export default About
